import classNames from "classnames";

import React from "react";
import { useRuleTranslation } from "./useRuleTranslation";

export function AutoBuySection({ displayed, hasSubscribeMode, companyName }) {
  const {
    subscribeEnabledText,
    subscribeDisabledText,
    companyDeliverySubscription,
    subscribeToCompanyDelivery,
  } = useRuleTranslation();

  return (
    <div className="rule__liked-products">
      <div
        className={classNames("rule__auto-buy", {
          "rule__auto-buy-is-disabled": !displayed,
        })}
      >
        <div className="rule__auto-buy-row">
          <h3>
            {hasSubscribeMode
              ? companyDeliverySubscription(companyName)
              : subscribeToCompanyDelivery(companyName)}
          </h3>
        </div>
      </div>
      {displayed ? (
        <p>
          {hasSubscribeMode
            ? subscribeEnabledText
            : subscribeDisabledText(companyName)}
        </p>
      ) : (
        ""
      )}
    </div>
  );
}
